export default {
  storagePrefix: process.env.REACT_APP_STORAGE_PREFIX || 'digital-trends-db-web-app-',
  buildCommit: process.env.REACT_APP_CODEBUILD_SOURCE_VERSION || process.env.REACT_APP_BUILD_COMMIT || 'dev',
  smartlookAppId: process.env.REACT_APP_SMARTLOOK_APP_ID || '',
};
